import React, { useEffect } from 'react';
import { Container, Paper } from '@mui/material';
import BoardsContainer from 'components/BoardsContainer/BoardsContainer';
import BoardsPageHeader from 'components/BoardsPageHeader';
import style from './MainPage.module.scss';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import { getFromLocal } from 'utils/localStorage';
import { useNavigate } from 'react-router-dom';
import { setOpen } from 'redux/slices/snackbarSlice';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'redux/store';

function MainPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const isAuth = getFromLocal('token');
    if (!isAuth) {
      dispatch(
        setOpen({
          open: true,
          message: `Необходима авторизация на сайте`,
          view: 'error',
        })
      );
      navigate('/welcome');
    }
  }, []);

  return (
    <div className={style.main}>
      <div className={style.wrapper}></div>
      <Paper sx={{ backgroundColor: 'transparent', pt: '20px', pb: '20px' }} elevation={0}>
        <Container sx={{ backgroundColor: 'transparent' }} maxWidth="lg">
          <Container>
            <BoardsPageHeader title={t('boards')} />
          </Container>
          <ErrorBoundary>
            <BoardsContainer />
          </ErrorBoundary>
        </Container>
      </Paper>
    </div>
  );
}

export default MainPage;
